__turbopack_context__.v({
  "lrActions": "LoginRequired-module__75Uulq__lrActions",
  "lrCancelBtn": "LoginRequired-module__75Uulq__lrCancelBtn",
  "lrCloseBtn": "LoginRequired-module__75Uulq__lrCloseBtn",
  "lrContent": "LoginRequired-module__75Uulq__lrContent",
  "lrImage": "LoginRequired-module__75Uulq__lrImage",
  "lrImageSection": "LoginRequired-module__75Uulq__lrImageSection",
  "lrLoginBtn": "LoginRequired-module__75Uulq__lrLoginBtn",
  "lrModal": "LoginRequired-module__75Uulq__lrModal",
  "lrOverlay": "LoginRequired-module__75Uulq__lrOverlay",
  "lrSubtitle": "LoginRequired-module__75Uulq__lrSubtitle",
  "lrTitle": "LoginRequired-module__75Uulq__lrTitle",
});
